import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import {
  CardComponent,
  CheckboxModule,
  FormFieldModule,
  SectionComponent,
  SectionHeaderComponent,
  TypographyModule,
} from "@bitwarden/components";
import { SendOptionsComponent } from "@bitwarden/send-ui";
import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  selector: "app-bv-send-options",
  templateUrl: "./bv-send-options.component.html",
  imports: [
    CardComponent,
    CheckboxModule,
    FormFieldModule,
    I18nPipe,
    ReactiveFormsModule,
    SectionComponent,
    SectionHeaderComponent,
    TypographyModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BvSendOptionsComponent extends SendOptionsComponent {}
